import Vue from 'vue'
import Router from 'vue-router'

// Tracks
import Tracks from '@/pages/tracks/Index';
import TrackDetails from '@/pages/tracks/TrackDetails';
import TrackObjects from '@/pages/tracks/TrackObjects';

// Users
import Users from '@/pages/users/Index';
import UserDetails from '@/pages/users/UserDetails';

// Buckets
import BucketDetails from '@/pages/buckets/BucketDetails'

// Objects
import ObjectDetails from '@/pages/objects/ObjectDetails'

// Observer
import ObserverDetails from '@/pages/observers/ObserverDetails'

Vue.use(Router)

let router = new Router ({
  linkActiveClass: 'active',
  routes: [
    {
		path: '/',
		component: Tracks
    },

    // Track
    {
		path: '/tracks',
		component: Tracks,
		name: 'tracks'
    },
    {
		path: '/tracks/:id',
		component: TrackDetails,
		name: 'track-details'
    },
    {
    	path: '/tracks/:id/objects',
    	component: TrackObjects,
    	name: 'track-objects'
    },

    // User
    {
		path: '/users',
		component: Users,
		name: 'users'
    },
    {
		path: '/users/:id',
		component: UserDetails,
		name: 'user-details'
    },
    
    // Bucket
    {
    	path: '/buckets/:id',
    	component: BucketDetails,
    	name: 'bucket-details'
    },

    // Object
    {
    	path: '/objects/:id',
    	component: ObjectDetails,
    	name: 'object-details'
    },

    // Observer
    {
    	path: '/observers/:id',
    	component: ObserverDetails,
    	name: 'observer-details'
    }

  ],
  scrollBehavior (to, from, savedPosition) {
	  return { x: 0, y: 0 }
	}
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js